/* FORGE cart-page offer — the progressive enhancement, and nothing more.

   The card (snippets/forge-cart-page-card.liquid) is a real <form method="post"> with a
   return_to, so with this file absent, blocked or broken every mode still works: the
   browser posts to /cart/add and comes back to /cart with the item in it. All this script
   does is replace that full page load with the same section swap assets/cart.js performs
   on a quantity change, and it falls back to a reload the moment anything is unexpected.

   TWO THINGS IT MUST GET RIGHT

   1. THE PRESSED BUTTON IS THE VARIANT. The size pills are `type=submit name="id"`, so the
      variant id lives on the submitter, and `new FormData(form)` does NOT include it — a
      submitter's name/value pair is contributed by the browser during native submission,
      not by the constructor. Read evt.submitter and append it by hand. Getting this wrong
      posts a form with no id, which is precisely the blind-add this card exists to avoid.

   2. EVERY LISTENER IS DELEGATED. The card is re-rendered by innerHTML replacement on
      every cart change, so a listener bound to the card or its form dies on the first
      update and the second add would fall through to a page reload. Bind to document. */
(function () {
  'use strict';

  var DISMISS_KEY = 'forgeCartPageUpsellDismissed';
  var OFF_CLASS = 'forge-cpu-off';

  var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

  /* ---- dismiss ---------------------------------------------------------------------
     The flag is read inline in sections/main-cart-footer.liquid so the card never flashes
     in for someone who already declined. This only handles the click. */
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest && evt.target.closest('[data-forge-cpu-dismiss]');
    if (!btn) {
      return;
    }
    evt.preventDefault();
    document.documentElement.classList.add(OFF_CLASS);
    /* The card is gone; without this focus falls to <body> (ACCESSIBILITY_RECHECK R5). */
    var co = document.getElementById('checkout');
    if (co) { co.focus(); }
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } catch (e) {
      /* private mode: the class alone still hides it for this page view */
    }
  });

  /* ---- the sections this page can repaint -------------------------------------------
     Same contract as CartItems.getSectionsToRender: replace the .js-contents of each.
     Read fresh on every add, because both nodes were themselves replaced by the last one. */
  function sectionsToRender() {
    var out = [];
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.dataset.id) {
        out.push({ id: id, section: el.dataset.id, selector: '.js-contents' });
      }
    });
    return out;
  }

  function innerHTMLOf(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var node = doc.querySelector(selector);
    return node ? node.innerHTML : null;
  }

  /* ---- add ---------------------------------------------------------------------------- */
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form.matches || !form.matches('[data-forge-cpu-form]')) {
      return;
    }

    var submitter = evt.submitter;
    /* No submitter means we cannot know which size was pressed. Let the browser do the
       native post rather than guess a variant. */
    if (!submitter || submitter.disabled) {
      return;
    }

    evt.preventDefault();

    var card = form.closest('[data-forge-cpu]');
    var errEl = form.querySelector('[data-forge-cpu-error]');
    if (card) {
      card.classList.add('is-busy');
    }
    if (errEl) {
      errEl.textContent = ''; /* stays rendered: role="alert" (ACCESSIBILITY_RECHECK R9) */
    }

    var body = new FormData(form);
    if (submitter.name) {
      body.append(submitter.name, submitter.value);
    }

    var sections = sectionsToRender();
    if (sections.length) {
      body.append('sections', sections.map(function (s) { return s.section; }).join(','));
      body.append('sections_url', window.location.pathname);
    }
    /* return_to is for the no-JS path only; posting it over fetch does nothing useful and
       Shopify echoes it back, so drop it to keep the request honest. */
    body.delete('return_to');

    fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body,
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          /* A real, reportable refusal (sold out between render and tap). Say it in place
             instead of reloading into a cart that looks like nothing happened. */
          var message = result.data.description || result.data.message || 'That size just sold out.';
          if (errEl) {
            errEl.textContent = message;
          } else {
            window.location.assign(cartUrl);
          }
          if (card) {
            card.classList.remove('is-busy');
          }
          return null;
        }

        var rendered = result.data.sections || {};
        var repainted = 0;
        sections.forEach(function (section) {
          var host = document.getElementById(section.id);
          var html = rendered[section.section];
          if (!host || !html) {
            return;
          }
          var target = host.querySelector(section.selector) || host;
          var replacement = innerHTMLOf(html, section.selector);
          if (replacement === null) {
            return;
          }
          target.innerHTML = replacement;
          repainted += 1;
        });

        if (repainted !== sections.length || !sections.length) {
          /* Partial repaint would leave the totals disagreeing with the line items. A
             reload is slow; a cart showing the wrong number is worse. */
          window.location.reload();
          return null;
        }

        /* Header count and anything else on the cartUpdate bus. /cart/add returns the line
           that was added, not the cart, so item_count has to be fetched separately.

           NOT window.PUB_SUB_EVENTS. assets/pubsub.js declares it `const`, and a top-level
           const is a script-scope binding that never lands on the window object — only the
           `function` declarations (publish, subscribe) do. Reaching for it through window
           reads undefined, the guard goes false, and the event is silently never sent.
           Measured on the draft 2026-08-17: the add worked, the totals repainted, and the
           header count sat at 1 with two lines in the cart. */
        var bus = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;
        return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (typeof window.publish === 'function' && bus && bus.cartUpdate) {
              window.publish(bus.cartUpdate, {
                source: 'forge-cart-page-upsell',
                cartData: cart,
              });
            }
          })
          .catch(function () { /* the cart is already correct on screen; the count can lag */ });
      })
      .catch(function () {
        window.location.reload();
      })
      .then(function () {
        var live = document.querySelector('[data-forge-cpu]');
        if (live) {
          live.classList.remove('is-busy');
        }
      });
  });
})();
